import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row-top w-full" }
const _hoisted_2 = { class: "col w-full" }
const _hoisted_3 = { class: "row w-full mtop-10" }
const _hoisted_4 = { class: "col-0-12 colend mright-04" }
const _hoisted_5 = { class: "main-m font-m" }
const _hoisted_6 = { class: "row w-full mtop-10" }
const _hoisted_7 = { class: "col-0-12 colend mright-04" }
const _hoisted_8 = { class: "main-m font-m" }
const _hoisted_9 = { class: "row w-full mtop-10" }
const _hoisted_10 = { class: "col-0-12 colend mright-04" }
const _hoisted_11 = { class: "main-m font-m" }
const _hoisted_12 = {
  key: 0,
  class: "txt-red mleft-04 font-sBold"
}
const _hoisted_13 = { class: "rowcenter w-full mtop-10 gap-08" }

import { ref, onMounted, watch,} from 'vue';
import { AdminApi, InstituteLightResponse, MedicalPersonLightResponse, MedicalPersonFinancialGroupResponse, MedicalPersonFinancialGroupRequest, ApiError } from '@/apiGenerate/medserver';
import { useI18n } from 'vue-i18n';
import Select from 'primevue/select';
import Checkbox from 'primevue/checkbox';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import { InstituteRoleType } from "@/models/institute.model";


export default /*@__PURE__*/_defineComponent({
  __name: 'esPersonFinancialGroupForm',
  props: {
    existPersonList: {},
    currentFinancialGroupId: {}
  },
  emits: ["refresh"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const toast = useToast();

const adminApi = new AdminApi(medServerApiConfig);

const confirmDisabled = ref<boolean>(false);
const instituteList = ref<InstituteLightResponse[]>([]);
const selectedInstitute = ref<InstituteLightResponse>(undefined);
const medicalPersonList = ref<MedicalPersonLightResponse[]>([]);
const selectedPerson = ref<MedicalPersonLightResponse>(undefined);
const medicalPersonFinancialGroupRequest = ref<MedicalPersonFinancialGroupRequest>(undefined);
const isOwner = ref<boolean>(false);
const displayAlertMessage = ref<boolean>(false);

const emits = __emit;

const initForm = () => {
   medicalPersonFinancialGroupRequest.value = {
        isOwner: false,
        personId: undefined
    };

    selectedPerson.value = undefined;
    selectedInstitute.value = undefined;
    isOwner.value = false;
}

const getAllHealthProGroupInstitutes = () => {
    adminApi.searchInstitute({type: InstituteRoleType.HealthProGroup}).then((response: InstituteLightResponse[]) => {
        instituteList.value = response.sort((a, b) =>
            a.name.localeCompare(b.name, 'fr', { sensitivity: 'base' })
        );
    }).catch(() => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t('error.DEFAULT')
        });
    });
}

const getMedicalPersonsByInstitute = async () => {
    if (selectedInstitute.value && selectedInstitute.value.id) {
        adminApi.getMedicalPersonsByInstitute({instituteId: selectedInstitute.value.id}).then((response: MedicalPersonLightResponse[]) => {
            medicalPersonList.value = response.filter((medicalPerson : MedicalPersonLightResponse) => {
                return !props.existPersonList || props.existPersonList.length === 0 || !props.existPersonList.every((existPerson: MedicalPersonFinancialGroupResponse) => existPerson.id === medicalPerson.id);
        });
        }).catch(() => {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: t('error.DEFAULT')
            });
        });
    }
}

const confirmForm = () => {
    if (selectedPerson.value?.id && props.currentFinancialGroupId) {
        confirmDisabled.value = true;
        medicalPersonFinancialGroupRequest.value.isOwner = isOwner.value;
        medicalPersonFinancialGroupRequest.value.personId = selectedPerson.value.id;

        adminApi.addMedicalPersonInCommonFinancialGroup({financialGroupId: props.currentFinancialGroupId, medicalPersonFinancialGroupRequest: medicalPersonFinancialGroupRequest.value}).then(() => {
            toastSuccess(toast, {
                summary: t('common.toast.success.add'),
                detail:  t('admin.financialGroup.person.add.message.success')
            });
            initForm();
            confirmDisabled.value = false;
            emits('refresh');
        }).catch((error: ApiError) => {
            if (error.status) {
                toastError(toast, {
                    summary: t('common.toast.error'),
                    detail: t(`error.${error.status}`)
                });
            } else {
                toastError(toast, {
                    summary: t('common.toast.error'),
                    detail: t('error.DEFAULT')
                });
            }
            
        });
    }
}

const cancelForm = () => {
    initForm();
}

watch(
    () => selectedInstitute.value,
  async () => {
    if (selectedInstitute.value) {
        await getMedicalPersonsByInstitute();
    }
  }
);

watch (
    () => isOwner.value,
    () => {
        if (isOwner.value) {
            displayAlertMessage.value = !!props.existPersonList.find((existPerson) => existPerson.isOwner && existPerson.id !== selectedPerson.value.id);
        } else {
             displayAlertMessage.value = false;
        }
    }
);

onMounted(async () => {
    await getAllHealthProGroupInstitutes();
    initForm();
});

return (_ctx: any,_cache: any) => {
  const _component_es_button = _resolveComponent("es-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('admin.financialGroup.person.form.institute')), 1)
          ]),
          _createVNode(_unref(Select), {
            modelValue: selectedInstitute.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedInstitute).value = $event)),
            options: instituteList.value,
            optionLabel: "name",
            size: "small",
            class: "w-full",
            filter: ""
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('admin.financialGroup.person.form.person')), 1)
          ]),
          _createVNode(_unref(Select), {
            modelValue: selectedPerson.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPerson).value = $event)),
            options: medicalPersonList.value,
            optionLabel: "name",
            size: "small",
            class: "w-full",
            disabled: !selectedInstitute.value
          }, null, 8, ["modelValue", "options", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('admin.financialGroup.person.form.isOwner')), 1)
          ]),
          _createVNode(_unref(Checkbox), {
            modelValue: isOwner.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isOwner).value = $event)),
            binary: "",
            disabled: !selectedPerson.value
          }, null, 8, ["modelValue", "disabled"]),
          (displayAlertMessage.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(t)('admin.financialGroup.person.form.ownerWarning')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_es_button, {
        label: _unref(t)('action.cancel'),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (cancelForm())),
        "is-primary": false
      }, null, 8, ["label"]),
      _createVNode(_component_es_button, {
        disabled: confirmDisabled.value,
        label: _unref(t)('action.save'),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (confirmForm())),
        "is-primary": true
      }, null, 8, ["disabled", "label"])
    ])
  ], 64))
}
}

})